import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const PropertyContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	padding: 20px;
	border-radius: 10px;
	background-color: rgba(255, 255, 255, 0.02);
`;

const PropertyContainerRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 20px;

	& > ${Text} {
		font-size: 16px;
		line-height: 18px;
		color: #ffffff;
		opacity: 0.5;
	}
`;

export { PropertyContainer, PropertyContainerRow };
